export default __webpack_public_path__ + "static/media/femaleShirt.d80bcbc4.png";